"use client";
import { jsx as g } from "react/jsx-runtime";
import { useMemo as d, useCallback as y, createContext as x, useContext as B } from "react";
import { logEvent as P } from "../atoms/api/analytics/events.js";
import { useInkeepConfig as C } from "./config-provider.js";
import { useUser as b } from "./user-provider.js";
const m = x(void 0), U = ({ children: e }) => {
  const { baseSettings: t, componentType: o } = C(), { apiKey: n, analyticsApiBaseUrl: s, tags: r, privacyPreferences: u, env: l } = t, { userProperties: i } = b(), a = d(
    () => ({
      widgetLibraryVersion: "0.5.40",
      componentType: o,
      tags: r
    }),
    [o, r]
  ), c = !u.optOutAllAnalytics && l !== "development", E = { logEvent: y(
    async (p) => {
      const f = {
        ...a,
        ...p.properties
      }, v = {
        eventName: p.eventName,
        properties: f,
        userProperties: i
      };
      c && P(v, n, s), t.onEvent?.(v);
    },
    [c, t, n, s, i, a]
  ) };
  return /* @__PURE__ */ g(m.Provider, { value: E, children: e });
}, $ = () => {
  const e = B(m);
  if (!e)
    throw new Error("useBaseEvents must be used within a BaseEventsProvider");
  return e;
};
export {
  U as BaseEventsProvider,
  $ as useBaseEvents
};
